import Highcharts, { PlotScatterOptions } from 'highcharts';
import { HighchartsReact } from 'highcharts-react-official';
import { Stack } from '@mantine/core';

interface ScatterChartProps {
  chartOptions: PlotScatterOptions;
  testId?: string;
}

export const ScatterChart = ({ chartOptions, testId }: ScatterChartProps) => {
  return (
    <Stack gap={'xs'} data-testid={testId}>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </Stack>
  );
};
